import { render, staticRenderFns } from "./kzevb-layout.vue?vue&type=template&id=6ed3878e"
import script from "./kzevb-layout.vue?vue&type=script&lang=js"
export * from "./kzevb-layout.vue?vue&type=script&lang=js"
import style0 from "./kzevb-layout.vue?vue&type=style&index=0&id=6ed3878e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports